module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "获取小程序 URL Link，适用于短信、邮件、网页、微信内等拉起小程序的业务场景。通过该接口，可以选择生成到期失效和永久有效的小程序链接，有数量限制 接口文档 https://developers.weixin.qq.com/miniprogram/dev/OpenApiDoc/qrcode-link/url-link/generateUrlLink.html",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "选择小程序"
    },
    model: {
      value: (_vm.check_wxappid),
      callback: function($$v) {
        _vm.check_wxappid = $$v
      },
      expression: "check_wxappid"
    }
  }, _vm._l((_vm.wx_appid_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "path"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "进入的小程序页面路径"
    },
    model: {
      value: (_vm.form.path),
      callback: function($$v) {
        _vm.$set(_vm.form, "path", $$v)
      },
      expression: "form.path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "query"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "进入小程序时的query，最大1024个字符，只支持数字，大小写英文以及部分特殊字符：!#$&'()*+,/:;=?@-._~%"
    },
    model: {
      value: (_vm.form.query),
      callback: function($$v) {
        _vm.$set(_vm.form, "query", $$v)
      },
      expression: "form.query"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "is_expire"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "默认值false。生成的 URL Link 类型，到期失效：true，永久有效：false。注意，永久有效 Link 和有效时间超过180天的到期失效 Link 的总数上限为10万个"
    },
    model: {
      value: (_vm.form.is_expire),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_expire", $$v)
      },
      expression: "form.is_expire"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "expire_type"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "默认值0.小程序 URL Link 失效类型，失效时间：0，失效间隔天数：1"
    },
    model: {
      value: (_vm.form.expire_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "expire_type", $$v)
      },
      expression: "form.expire_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "expire_time"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "到期失效的 URL Link 的失效时间，为 Unix 时间戳。生成的到期失效 URL Link 在该时间前有效。最长有效期为1年。expire_type 为 0 必填"
    },
    model: {
      value: (_vm.form.expire_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "expire_time", $$v)
      },
      expression: "form.expire_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "expire_interval"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "到期失效的URL Link的失效间隔天数。生成的到期失效URL Link在该间隔时间到达前有效。最长间隔天数为365天。expire_type 为 1 必填\n"
    },
    model: {
      value: (_vm.form.expire_interval),
      callback: function($$v) {
        _vm.$set(_vm.form, "expire_interval", $$v)
      },
      expression: "form.expire_interval"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "env_version"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "默认值release。要打开的小程序版本。正式版为 release，体验版为trial，开发版为develop，仅在微信外打开时生效"
    },
    model: {
      value: (_vm.form.env_version),
      callback: function($$v) {
        _vm.$set(_vm.form, "env_version", $$v)
      },
      expression: "form.env_version"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleGetQRcode
    }
  }, [_vm._v("生成链接")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "短链接",
      "disabled": true
    },
    model: {
      value: (_vm.resurl),
      callback: function($$v) {
        _vm.resurl = $$v
      },
      expression: "resurl"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-595de23b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-595de23b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/get_shortlink.vue
// module id = 2740
// module chunks = 0